import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SingleStepSportEventFragmentDoc } from './SingleStepSportEvent.fragment';
export type SingleStepTeamFragment = {
	__typename?: 'SportCompetitorV2';
	id: string;
	objectType: Types.ObjectType;
	objectId: number;
	content: { __typename?: 'SportCompetitorContentV2'; name: string; iconUrl?: string | null };
	sportEventBucketsV2: {
		__typename?: 'SportEventBucketsConnectionV2';
		edges?: Array<{
			__typename?: 'SportEventBucketsEdgeV2';
			key: {
				__typename?: 'SportEventAggregationKeyV2';
				competition?: {
					__typename?: 'SportCompetitionV2';
					id: string;
					content: {
						__typename?: 'SportCompetitionContentV2';
						name: string;
						fullPath: string;
						iconUrl?: string | null;
					};
				} | null;
			};
			node: {
				__typename?: 'SportEventsConnectionV2';
				edges?: Array<{
					__typename?: 'SportEventsEdgeV2';
					node:
						| { __typename?: 'MultiStepSportEvent' }
						| {
								__typename: 'SingleStepSportEvent';
								id: string;
								objectType: Types.ObjectType;
								objectId: number;
								sport: Types.SportType;
								offerCount: number;
								content: {
									__typename?: 'SingleStepSportEventContent';
									name: string;
									status: Types.SportEventStatus;
									startAt: any;
									endAt?: any | null;
									fullPath?: string | null;
									venue?: { __typename?: 'SportVenue'; venueID: number; name: string } | null;
									competitionStage: {
										__typename?: 'SportCompetitionStageV2';
										name: Types.SportCompetitionStageName;
										number?: number | null;
									};
									pastEvents: Array<{
										__typename?: 'SingleStepSportEvent';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										sport: Types.SportType;
										competition?: {
											__typename?: 'SportCompetitionV2';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											sport: Types.SportType;
											content: {
												__typename?: 'SportCompetitionContentV2';
												fullPath: string;
												name: string;
											};
										} | null;
										competitors: {
											__typename?: 'SingleStepSportCompetitorsV2';
											homeTeam: {
												__typename?: 'SingleStepSportCompetitorV2';
												score?: number | null;
												competitors: Array<{
													__typename?: 'SportCompetitorV2';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													sport: Types.SportType;
													content: {
														__typename?: 'SportCompetitorContentV2';
														firstName: string;
														fullPath?: string | null;
														lastName: string;
														name: string;
														iconUrl?: string | null;
													};
												}>;
											};
											awayTeam: {
												__typename?: 'SingleStepSportCompetitorV2';
												score?: number | null;
												competitors: Array<{
													__typename?: 'SportCompetitorV2';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													sport: Types.SportType;
													content: {
														__typename?: 'SportCompetitorContentV2';
														firstName: string;
														fullPath?: string | null;
														lastName: string;
														name: string;
														iconUrl?: string | null;
													};
												}>;
											};
										};
										content: {
											__typename?: 'SingleStepSportEventContent';
											name: string;
											startAt: any;
											status: Types.SportEventStatus;
											season?: {
												__typename?: 'SportSeason';
												name: string;
												seasonID: number;
											} | null;
										};
									}>;
								};
								mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								competition?: {
									__typename?: 'SportCompetitionV2';
									id: string;
									objectId: number;
									sport: Types.SportType;
									activeSeason?: {
										__typename?: 'SportSeason';
										name: string;
										seasonID: number;
									} | null;
									content: {
										__typename?: 'SportCompetitionContentV2';
										name: string;
										fullPath: string;
										iconUrl?: string | null;
									};
								} | null;
								competitors: {
									__typename?: 'SingleStepSportCompetitorsV2';
									homeTeam: {
										__typename?: 'SingleStepSportCompetitorV2';
										score?: number | null;
										winner: boolean;
										competitors: Array<{
											__typename?: 'SportCompetitorV2';
											id: string;
											objectId: number;
											content: {
												__typename?: 'SportCompetitorContentV2';
												name: string;
												iconUrl?: string | null;
												fullPath?: string | null;
											};
										}>;
									};
									awayTeam: {
										__typename?: 'SingleStepSportCompetitorV2';
										score?: number | null;
										winner: boolean;
										competitors: Array<{
											__typename?: 'SportCompetitorV2';
											id: string;
											objectId: number;
											content: {
												__typename?: 'SportCompetitorContentV2';
												name: string;
												iconUrl?: string | null;
												fullPath?: string | null;
											};
										}>;
									};
								};
								watchNowOffer?: {
									__typename?: 'SportOffer';
									monetizationType: Types.MonetizationType;
									presentationType: Types.PresentationType;
									audioLanguage?: string | null;
									standardWebURL?: string | null;
									sportObjectType: Types.SportObjectType;
									package: {
										__typename?: 'Package';
										id: string;
										packageId: number;
										technicalName: string;
										clearName: string;
										shortName: string;
										monetizationTypes: Array<Types.MonetizationType>;
										iconWide: string;
									};
								} | null;
								offers: Array<{
									__typename?: 'SportOffer';
									monetizationType: Types.MonetizationType;
									presentationType: Types.PresentationType;
									audioLanguage?: string | null;
									standardWebURL?: string | null;
									sportObjectType: Types.SportObjectType;
									package: {
										__typename?: 'Package';
										id: string;
										packageId: number;
										technicalName: string;
										clearName: string;
										shortName: string;
										monetizationTypes: Array<Types.MonetizationType>;
									};
								}>;
						  };
				}> | null;
			};
		}> | null;
	};
};

export const SingleStepTeamFragmentDoc = gql`
	fragment SingleStepTeam on SportCompetitorV2 {
		id
		objectType
		objectId
		content(country: $country, language: $language) {
			name
			iconUrl
		}
		sportEventBucketsV2(
			country: $country
			timezoneOffset: $timezoneOffset
			filter: $filter
			groupBy: COMPETITION
			first: $first
			bucketSize: $bucketSize
			sortOrder: $sortOrder
		) {
			edges {
				key {
					competition {
						id
						content(country: $country, language: $language) {
							name
							fullPath
							iconUrl
						}
					}
				}
				node {
					edges {
						node {
							... on SingleStepSportEvent {
								...SingleStepSportEvent
							}
						}
					}
				}
			}
		}
	}
	${SingleStepSportEventFragmentDoc}
`;
